// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"star-tooltip_tooltipContainer_1Bs","tooltipActions":"star-tooltip_tooltipActions_2C9","tooltipActionShowMeHow":"star-tooltip_tooltipActionShowMeHow_1vR"};